// extracted by mini-css-extract-plugin
export const stepperItem__base = "slidesStepper-module--stepperItem__base--3QsHA";
export const stepperItem__active = "slidesStepper-module--stepperItem__active--3Nprj";
export const slidesStepper = "slidesStepper-module--slidesStepper--2VgIc";